(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsSortSelector', rmsSortSelector);

    function rmsSortSelector(lodash, CommonHelper) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                available: '=',
                options: '=?',
                refresh: '=?',
                readonly: '=?',
            },
            controller: rmsSortSelectorCtrl,
            templateUrl: 'common/app/components/sort-selector',
            link: function (scope, elem, attr, ctrl) {
                scope.ngModelCtrl = ctrl;
                var vm = scope.scCtrl;/**/
                vm.available_is_active = false;

                ctrl.$render = function() {
                    vm.available = lodash.differenceBy(vm.appliedAvailable, ctrl.$viewValue, vm.valueField);
                    if (CommonHelper.isEmpty(vm.appliedAvailable)) {
                        return;
                    }
                    const previousSelector = angular.copy(vm.selected);
                    vm.selected = lodash.intersectionBy(ctrl.$viewValue, vm.appliedAvailable, vm.valueField).map(function(_selectedItem, index) {
                        const previous = lodash.find(previousSelector, { [vm.valueField]: _selectedItem[vm.valueField]});
                        if (previous) {
                            _selectedItem.sort = previous.sort;
                            _selectedItem[vm.sortField] = previous[vm.sortField];
                        }
                        return _selectedItem;
                    });
                    vm.selected = lodash.sortBy(vm.selected, [vm.sortField]);
                    ctrl.$setViewValue(vm.selected);
                    if (vm.selected.length === 0) {
                        vm.available_is_active = true;
                    }
                };

                scope.$watch('available', function(newVal) {
                   if (!lodash.isEqual(newVal, vm.appliedAvailable)) {
                       vm.appliedAvailable = lodash.filter(angular.copy(newVal), { sortable: true });
                       ctrl.$render();
                   }
                });

                vm.available_is_active = false; // will always be false on default
                vm.openAvailable = openAvailable;
                vm.closeAvailable = closeAvailable;
                vm.addItem = addItem;
                vm.removeItem = removeItem;
                vm.addAll = addAll;
                vm.removeAll = removeAll;
                vm.toggleSortDirection = toggleSortDirection;
                vm.isReadOnly = isReadOnly;
                scope.refresh = refresh;

                function refresh() {
                    ctrl.$render();
                }

                function addItem(item) {
                    const sortNum = vm.selected.reduce((result, _selected) => {
                        return Math.max(result, _selected[vm.sortField]);
                    }, 0);
                    var itemObj = lodash.remove(vm.available, {[vm.valueField]: item[vm.valueField]}).map((_item) => {
                        _item.sort = 'asc';
                        _item[vm.sortField] = (sortNum + 1);
                        return _item;
                    });
                    vm.selected = vm.selected.concat(itemObj);
                    vm.reorderItems();
                    ctrl.$setViewValue(vm.selected);
                }

                function removeItem(item) {
                    var itemObj = lodash.remove(vm.selected, {[vm.valueField]: item[vm.valueField]});
                    vm.available = vm.available.concat(itemObj);
                    vm.reorderItems();
                    ctrl.$setViewValue(vm.selected);
                }

                function addAll() {
                    let index = 0;
                    vm.selected = vm.selected.concat(vm.available).map((_item) => {
                        _item.sort = 'asc';
                        _item[vm.sortField] = index++;
                        return _item;
                    });
                    vm.available = [];
                    vm.reorderItems();
                    ctrl.$setViewValue(vm.selected);
                }

                function removeAll() {
                    vm.available = vm.available.concat(vm.selected);
                    vm.selected = [];
                    vm.reorderItems();
                    ctrl.$setViewValue(vm.selected);
                }

                function openAvailable() {
                    vm.available_is_active = true;
                }

                function closeAvailable() {
                    vm.available_is_active = false;
                }

                function toggleSortDirection(item) {
                    item.sort = (item.sort === 'asc') ? 'desc' : 'asc';
                }

                function isReadOnly() {
                    return lodash.get(scope, 'readonly', false);
                }
            }
        };
    }

    function rmsSortSelectorCtrl($scope, lodash) {

        this.$onInit = function() {
            $scope.scCtrl = {
                labelField: lodash.get($scope.options, 'labelField', 'label'),
                valueField: lodash.get($scope.options, 'valueField', 'value'),
                sortField: lodash.get($scope.options, 'sortField', 'sort_position'),
                appliedAvailable: null,
            };
            var vm = $scope.scCtrl;

            vm.selectedConfig = {
                placeholder: function () {
                    return '<li class="drop-here"><i class="fa fa-bars"></i></i><span>Drop Here</span></li>'
                },
                hint: function (element) {
                    var text = element.find('span').text();
                    return '<div class="options-selector-hint">' + text + '</div>'
                },
                disabled: '.disabled-item',
                change: function(e) {
                    var oldIndex = e.oldIndex,
                        newIndex = e.newIndex;

                    var itemMoved = vm.selected[oldIndex];
                    vm.selected.splice(oldIndex, 1);
                    vm.selected.splice(newIndex, 0, itemMoved);
                    // $timeout(function() {
                    vm.reorderItems();
                    $scope.ngModelCtrl.$setViewValue(vm.selected);
                    // });
                }
            };

            vm.reorderItems = function() {
                vm.selected = vm.selected.map(function(item, index) {
                    item[vm.sortField] = index + 1;
                    return item;
                });
            }
        }
    }
})();